// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuarantineSummary } from './quarantine-summary';
import {
    QuarantineSummaryFromJSON,
    QuarantineSummaryFromJSONTyped,
    QuarantineSummaryToJSON,
    QuarantineSummaryToJSONTyped,
} from './quarantine-summary';
import type { RunStatistics } from './run-statistics';
import {
    RunStatisticsFromJSON,
    RunStatisticsFromJSONTyped,
    RunStatisticsToJSON,
    RunStatisticsToJSONTyped,
} from './run-statistics';
import type { ReviewStatus } from './review-status';
import {
    ReviewStatusFromJSON,
    ReviewStatusFromJSONTyped,
    ReviewStatusToJSON,
    ReviewStatusToJSONTyped,
} from './review-status';
import type { RunListItem } from './run-list-item';
import {
    RunListItemFromJSON,
    RunListItemFromJSONTyped,
    RunListItemToJSON,
    RunListItemToJSONTyped,
} from './run-list-item';
import type { RunStatus } from './run-status';
import {
    RunStatusFromJSON,
    RunStatusFromJSONTyped,
    RunStatusToJSON,
    RunStatusToJSONTyped,
} from './run-status';
import type { ConformanceError } from './conformance-error';
import {
    ConformanceErrorFromJSON,
    ConformanceErrorFromJSONTyped,
    ConformanceErrorToJSON,
    ConformanceErrorToJSONTyped,
} from './conformance-error';

/**
 * 
 * @export
 * @interface GetRunResponseContent
 */
export interface GetRunResponseContent {
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    assignedTo?: string;
    /**
     * 
     * @type {Array<RunListItem>}
     * @memberof GetRunResponseContent
     */
    childRuns?: Array<RunListItem>;
    /**
     * 
     * @type {Array<ConformanceError>}
     * @memberof GetRunResponseContent
     */
    conformanceErrors?: Array<ConformanceError>;
    /**
     * 
     * @type {Date}
     * @memberof GetRunResponseContent
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    dataStreamId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRunResponseContent
     */
    dryRun: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    dtaVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    inputLocation?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetRunResponseContent
     */
    lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    parentRunId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    quarantineLocation?: string;
    /**
     * 
     * @type {QuarantineSummary}
     * @memberof GetRunResponseContent
     */
    quarantineSummary?: QuarantineSummary;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    resolution?: string;
    /**
     * 
     * @type {ReviewStatus}
     * @memberof GetRunResponseContent
     */
    reviewStatus?: ReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    runId: string;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    specId: string;
    /**
     * 
     * @type {RunStatistics}
     * @memberof GetRunResponseContent
     */
    statistics?: RunStatistics;
    /**
     * 
     * @type {RunStatus}
     * @memberof GetRunResponseContent
     */
    status: RunStatus;
    /**
     * 
     * @type {string}
     * @memberof GetRunResponseContent
     */
    studyId: string;
}



/**
 * Check if a given object implements the GetRunResponseContent interface.
 */
export function instanceOfGetRunResponseContent(value: object): value is GetRunResponseContent {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('runId' in value) || value['runId'] === undefined) return false;
    if (!('specId' in value) || value['specId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    return true;
}

export function GetRunResponseContentFromJSON(json: any): GetRunResponseContent {
    return GetRunResponseContentFromJSONTyped(json, false);
}

export function GetRunResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRunResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'childRuns': json['childRuns'] == null ? undefined : ((json['childRuns'] as Array<any>).map(RunListItemFromJSON)),
        'conformanceErrors': json['conformanceErrors'] == null ? undefined : ((json['conformanceErrors'] as Array<any>).map(ConformanceErrorFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'dataStreamId': json['dataStreamId'] == null ? undefined : json['dataStreamId'],
        'dryRun': json['dryRun'],
        'dtaVersion': json['dtaVersion'] == null ? undefined : json['dtaVersion'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'inputLocation': json['inputLocation'] == null ? undefined : json['inputLocation'],
        'lastModifiedAt': (new Date(json['lastModifiedAt'])),
        'parentRunId': json['parentRunId'] == null ? undefined : json['parentRunId'],
        'quarantineLocation': json['quarantineLocation'] == null ? undefined : json['quarantineLocation'],
        'quarantineSummary': json['quarantineSummary'] == null ? undefined : QuarantineSummaryFromJSON(json['quarantineSummary']),
        'resolution': json['resolution'] == null ? undefined : json['resolution'],
        'reviewStatus': json['reviewStatus'] == null ? undefined : ReviewStatusFromJSON(json['reviewStatus']),
        'runId': json['runId'],
        'specId': json['specId'],
        'statistics': json['statistics'] == null ? undefined : RunStatisticsFromJSON(json['statistics']),
        'status': RunStatusFromJSON(json['status']),
        'studyId': json['studyId'],
    };
}

export function GetRunResponseContentToJSON(json: any): GetRunResponseContent {
    return GetRunResponseContentToJSONTyped(json, false);
}

export function GetRunResponseContentToJSONTyped(value?: GetRunResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedTo': value['assignedTo'],
        'childRuns': value['childRuns'] == null ? undefined : ((value['childRuns'] as Array<any>).map(RunListItemToJSON)),
        'conformanceErrors': value['conformanceErrors'] == null ? undefined : ((value['conformanceErrors'] as Array<any>).map(ConformanceErrorToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'dataStreamId': value['dataStreamId'],
        'dryRun': value['dryRun'],
        'dtaVersion': value['dtaVersion'],
        'errorMessage': value['errorMessage'],
        'fileName': value['fileName'],
        'inputLocation': value['inputLocation'],
        'lastModifiedAt': ((value['lastModifiedAt']).toISOString()),
        'parentRunId': value['parentRunId'],
        'quarantineLocation': value['quarantineLocation'],
        'quarantineSummary': QuarantineSummaryToJSON(value['quarantineSummary']),
        'resolution': value['resolution'],
        'reviewStatus': ReviewStatusToJSON(value['reviewStatus']),
        'runId': value['runId'],
        'specId': value['specId'],
        'statistics': RunStatisticsToJSON(value['statistics']),
        'status': RunStatusToJSON(value['status']),
        'studyId': value['studyId'],
    };
}
